import React from 'react';

const Hero = () => {
  return (
    <section id="home" className="hero">
      <div className="container">
        <h2>Welcome to 2CBNTV</h2>
        <p>We do not profit from this campaign. We just want to see you in heaven. Please take a few moments to watch at least a snippet of the video below 🙏</p>
      </div>
    </section>
  );
};

export default Hero;
